import { render, staticRenderFns } from "./myprojects.vue?vue&type=template&id=00260bdc&"
import script from "./myprojects.vue?vue&type=script&lang=ts&"
export * from "./myprojects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports